import React from 'react';

import { lensTokens } from '~/configs/unifiedAnalyticsTheme';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, ButtonBase, Tooltip, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { FONT_STACK_SUISSE_INTL } from '~/components/brand/brandTokens';

import { FEWER_METRICS_DISABLED_HINT } from './moreMetricsState';

/** The strip footer's right-hand toggle for the second tile row. */
export default function MoreMetricsToggle({
  controls,
  count,
  disabled,
  onToggle,
  open,
}: {
  /** Id of the second tile row, for aria-controls while it is open. */
  controls?: string;
  count: number;
  disabled: boolean;
  onToggle: () => void;
  open: boolean;
}) {
  const theme = useTheme();
  const tokens = lensTokens(theme);
  return (
    <Tooltip arrow placement="top" title={disabled ? FEWER_METRICS_DISABLED_HINT : ''}>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <ButtonBase
          aria-controls={open ? controls : undefined}
          aria-expanded={open}
          disabled={disabled}
          onClick={onToggle}
          sx={{
            alignItems: 'center',
            borderRadius: '8px',
            color: alpha(theme.palette.text.primary, 0.62),
            display: 'inline-flex',
            fontFamily: FONT_STACK_SUISSE_INTL,
            fontSize: 12.5,
            gap: 0.25,
            minHeight: 28,
            px: 1.25,
            '&:hover': { backgroundColor: alpha(tokens.accent, 0.06) },
            '&:focus-visible': { outline: `2px solid ${tokens.accent}`, outlineOffset: -2 },
            '&.Mui-disabled': { opacity: 0.45 },
          }}
        >
          {open ? 'Fewer metrics' : `More metrics (${count})`}
          <KeyboardArrowDownIcon sx={{ fontSize: 16, transform: open ? 'rotate(180deg)' : 'none' }} />
        </ButtonBase>
      </Box>
    </Tooltip>
  );
}
